import Automations from './Automations';
import AutomationsModule from './AutomationsModule';

export default {
  Automations,
  AutomationsModule,
};
